import React from 'react'
import MoreInformation from '../../components/User/MerchantOnboard/MoreInformation';

const OnBoardInformation = () => {
  return (
    <MoreInformation />
  )
}

export default OnBoardInformation;